export var ColorTokens;
(function (ColorTokens) {
    ColorTokens["Grey_Charcoal"] = "Grey_Charcoal";
    ColorTokens["Primary_100"] = "Primary_100";
    ColorTokens["Primary_02"] = "Primary_02";
    ColorTokens["Primary_05"] = "Primary_05";
    ColorTokens["Primary_10"] = "Primary_10";
    ColorTokens["Primary_20"] = "Primary_20";
    ColorTokens["Secondary_Milk"] = "Secondary_Milk";
    ColorTokens["Secondary_100"] = "Secondary/100";
    ColorTokens["Secondary_200"] = "Secondary/200";
    ColorTokens["Secondary_300"] = "Secondary_300";
    ColorTokens["Secondary_02"] = "Secondary/02";
    ColorTokens["Secondary_05"] = "Secondary/05";
    ColorTokens["Secondary_10"] = "Secondary/10";
    ColorTokens["Secondary_20"] = "Secondary/20";
    ColorTokens["Tertiary_100"] = "Tertiary_100";
    ColorTokens["Tertiary_20"] = "Tertiary_20";
    ColorTokens["Tertiary_10"] = "Tertiary_10";
    ColorTokens["Tertiary_05"] = "Tertiary_05";
    ColorTokens["Tertiary_02"] = "Tertiary_02";
    ColorTokens["Grey_Chalk"] = "Grey_Chalk";
    ColorTokens["Grey_Smoke"] = "Grey_Smoke";
    ColorTokens["Grey_Milk"] = "Grey_Milk";
    ColorTokens["Grey_Milk_1"] = "Grey/Milk+1";
    ColorTokens["Grey_Night"] = "Grey_Night";
    ColorTokens["System_Error"] = "System_Error";
    ColorTokens["System_Error_05"] = "System_Error_05";
    ColorTokens["System_Happy"] = "System_Happy";
    ColorTokens["System_Warning"] = "System_Warning";
    ColorTokens["System_Warning_BG"] = "System_Warning_BG";
    ColorTokens["White"] = "white";
    ColorTokens["White_20"] = "white_20";
    ColorTokens["Grey_50"] = "grey-50";
    ColorTokens["Grey_100"] = "grey-100";
    ColorTokens["Grey_200"] = "grey-200";
    ColorTokens["Grey_300"] = "grey-300";
    ColorTokens["Grey_400"] = "grey-400";
    ColorTokens["Grey_500"] = "grey-500";
    ColorTokens["Grey_550"] = "grey-550";
    ColorTokens["Grey_600"] = "grey-600";
    ColorTokens["Grey_700"] = "grey-700";
    ColorTokens["Black"] = "black";
    ColorTokens["Black_20"] = "black-20";
    ColorTokens["Interaction_10"] = "interaction-10";
    ColorTokens["Interaction_20"] = "interaction-20";
    ColorTokens["Interaction_30"] = "interaction-30";
    ColorTokens["Interaction_40"] = "interaction-40";
    ColorTokens["Interaction_50"] = "interaction-50";
    ColorTokens["Interaction_60"] = "interaction-60";
    ColorTokens["Interaction_70"] = "interaction-70";
    ColorTokens["Interaction_80"] = "interaction-80";
    ColorTokens["Interaction_90"] = "interaction-90";
    /**
     * @deprecated
     */
    ColorTokens["Interaction_100"] = "interaction-100";
    ColorTokens["Positive_10"] = "positive-10";
    ColorTokens["Positive_20"] = "positive-20";
    ColorTokens["Positive_30"] = "positive-30";
    ColorTokens["Positive_40"] = "positive-40";
    ColorTokens["Positive_50"] = "positive-50";
    ColorTokens["Positive_60"] = "positive-60";
    ColorTokens["Positive_70"] = "positive-70";
    ColorTokens["Positive_80"] = "positive-80";
    ColorTokens["Positive_90"] = "positive-90";
    /**
     * @deprecated
     */
    ColorTokens["Positive_100"] = "positive-100";
    ColorTokens["Negative_10"] = "negative-10";
    ColorTokens["Negative_20"] = "negative-20";
    ColorTokens["Negative_30"] = "negative-30";
    ColorTokens["Negative_40"] = "negative-40";
    ColorTokens["Negative_50"] = "negative-50";
    ColorTokens["Negative_60"] = "negative-60";
    ColorTokens["Negative_70"] = "negative-70";
    ColorTokens["Negative_80"] = "negative-80";
    ColorTokens["Negative_90"] = "negative-90";
    /**
     * @deprecated
     */
    ColorTokens["Negative_100"] = "negative-100";
    ColorTokens["Warning_25"] = "warning-25";
    ColorTokens["Warning_50"] = "warning-50";
    ColorTokens["Warning_200"] = "warning-20";
    ColorTokens["Warning_100"] = "warning-100";
    ColorTokens["Highlight_10"] = "highlight-10";
    ColorTokens["Highlight_20"] = "highlight-20";
    ColorTokens["Highlight_30"] = "highlight-30";
    ColorTokens["Highlight_40"] = "highlight-40";
    ColorTokens["Highlight_50"] = "highlight-50";
    ColorTokens["Highlight_60"] = "highlight-60";
    ColorTokens["Highlight_70"] = "highlight-70";
    ColorTokens["Highlight_80"] = "highlight-80";
    ColorTokens["Highlight_90"] = "highlight-90";
    ColorTokens["Purple_10"] = "purple-10";
    ColorTokens["Purple_20"] = "purple-20";
    ColorTokens["Purple_30"] = "purple-30";
    ColorTokens["Purple_40"] = "purple-40";
    ColorTokens["Purple_50"] = "purple-50";
    ColorTokens["Purple_60"] = "purple-60";
    ColorTokens["Purple_70"] = "purple-70";
    ColorTokens["Purple_80"] = "purple-80";
    ColorTokens["Purple_90"] = "purple-90";
    ColorTokens["Red_10"] = "red-10";
    ColorTokens["Red_20"] = "red-20";
    ColorTokens["Red_30"] = "red-30";
    ColorTokens["Red_40"] = "red-40";
    ColorTokens["Red_50"] = "red-50";
    ColorTokens["Red_60"] = "red-60";
    ColorTokens["Red_70"] = "red-70";
    ColorTokens["Red_80"] = "red-80";
    ColorTokens["Red_90"] = "red-90";
    ColorTokens["Green_10"] = "green-10";
    ColorTokens["Green_20"] = "green-20";
    ColorTokens["Green_30"] = "green-30";
    ColorTokens["Green_40"] = "green-40";
    ColorTokens["Green_50"] = "green-50";
    ColorTokens["Green_60"] = "green-60";
    ColorTokens["Green_70"] = "green-70";
    ColorTokens["Green_80"] = "green-80";
    ColorTokens["Green_90"] = "green-90";
    ColorTokens["Yellow_10"] = "yellow-10";
    ColorTokens["Yellow_20"] = "yellow-20";
    ColorTokens["Yellow_30"] = "yellow-30";
    ColorTokens["Yellow_40"] = "yellow-40";
    ColorTokens["Yellow_50"] = "yellow-50";
    ColorTokens["Yellow_60"] = "yellow-60";
    ColorTokens["Yellow_70"] = "yellow-70";
    ColorTokens["Yellow_80"] = "yellow-80";
    ColorTokens["Yellow_90"] = "yellow-90";
    ColorTokens["Orange_50"] = "orange-50";
    ColorTokens["Orange_100"] = "orange-100";
    ColorTokens["Orange_200"] = "orange-200";
    ColorTokens["Orange_300"] = "orange-300";
    ColorTokens["Orange_400"] = "orange-400";
    ColorTokens["Orange_500"] = "orange-500";
    ColorTokens["Orange_600"] = "orange-600";
    ColorTokens["Orange_700"] = "orange-700";
    ColorTokens["Orange_800"] = "orange-800";
    ColorTokens["Orange_900"] = "orange-900";
    ColorTokens["Blue_50"] = "blue-50";
    ColorTokens["Blue_100"] = "blue-100";
    ColorTokens["Blue_200"] = "blue-200";
    ColorTokens["Blue_300"] = "blue-300";
    ColorTokens["Blue_400"] = "blue-400";
    ColorTokens["Blue_500"] = "blue-500";
    ColorTokens["Blue_600"] = "blue-600";
    ColorTokens["Blue_700"] = "blue-700";
    ColorTokens["Blue_800"] = "blue-800";
    ColorTokens["Blue_900"] = "blue-900";
    ColorTokens["Teal_10"] = "teal-10";
    ColorTokens["Teal_20"] = "teal-20";
    ColorTokens["Teal_30"] = "teal-30";
    ColorTokens["Teal_40"] = "teal-40";
    ColorTokens["Teal_50"] = "teal-50";
    ColorTokens["Teal_60"] = "teal-60";
    ColorTokens["Teal_70"] = "teal-70";
    ColorTokens["Teal_80"] = "teal-80";
    ColorTokens["Teal_90"] = "teal-90";
    /**
     * @deprecated
     */
    ColorTokens["Teal_100"] = "teal-100";
    ColorTokens["Aqua_10"] = "aqua-10";
    ColorTokens["Aqua_20"] = "aqua-20";
    ColorTokens["Aqua_30"] = "aqua-30";
    ColorTokens["Aqua_40"] = "aqua-40";
    ColorTokens["Aqua_50"] = "aqua-50";
    ColorTokens["Aqua_60"] = "aqua-60";
    ColorTokens["Aqua_70"] = "aqua-70";
    ColorTokens["Aqua_80"] = "aqua-80";
    ColorTokens["Aqua_90"] = "aqua-90";
    /**
     * @deprecated
     */
    ColorTokens["Aqua_100"] = "aqua-100";
    ColorTokens["Pink_10"] = "pink-10";
    ColorTokens["Pink_20"] = "pink-20";
    ColorTokens["Pink_30"] = "pink-30";
    ColorTokens["Pink_40"] = "pink-40";
    ColorTokens["Pink_50"] = "pink-50";
    ColorTokens["Pink_60"] = "pink-60";
    ColorTokens["Pink_70"] = "pink-70";
    ColorTokens["Pink_80"] = "pink-80";
    ColorTokens["Pink_90"] = "pink-90";
    /**
     * @deprecated
     */
    ColorTokens["Pink_100"] = "pink-100";
    ColorTokens["Brown_10"] = "brown-10";
    ColorTokens["Brown_20"] = "brown-20";
    ColorTokens["Brown_30"] = "brown-30";
    ColorTokens["Brown_40"] = "brown-40";
    ColorTokens["Brown_50"] = "brown-50";
    ColorTokens["Brown_60"] = "brown-60";
    ColorTokens["Brown_70"] = "brown-70";
    ColorTokens["Brown_80"] = "brown-80";
    ColorTokens["Brown_90"] = "brown-90";
    ColorTokens["Transparent"] = "transparent";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_10"] = "indigo-10";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_20"] = "indigo-20";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_30"] = "indigo-30";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_40"] = "indigo-40";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_50"] = "indigo-50";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_60"] = "indigo-60";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_70"] = "indigo-70";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_80"] = "indigo-80";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_90"] = "indigo-90";
    /**
     * @deprecated
     */
    ColorTokens["Indigo_100"] = "indigo-100";
    ColorTokens["Success_50"] = "success-50";
    ColorTokens["Success_200"] = "success-20";
    ColorTokens["Success_100"] = "success-100";
    ColorTokens["Error_50"] = "error-50";
    ColorTokens["Error_200"] = "error-20";
    ColorTokens["Error_100"] = "error-100";
    ColorTokens["Error_300"] = "error-300";
    ColorTokens["Google"] = "google";
    ColorTokens["Grey_Charcoal1"] = "Grey_Charcoal1";
    ColorTokens["Light_Cream"] = "Light_Cream";
    ColorTokens["Dark_Cream"] = "Dark_Cream";
    ColorTokens["Light_Black"] = "Light_Black";
    ColorTokens["Light_Blue"] = "Light_Blue";
    ColorTokens["Dark_Blue"] = "Dark_Blue";
    ColorTokens["PERSIAN_INDIGO"] = "PERSIAN_INDIGO";
    ColorTokens["CATALINA_BLUE"] = "CATALINA_BLUE";
    ColorTokens["MODERATE_GREEN"] = "MODERATE_GREEN";
    ColorTokens["PERSIAN_JEWEL"] = "PERSIAN_JEWEL";
    ColorTokens["DARK_MODE"] = "DARK_MODE";
    ColorTokens["DARK_MODE_DIVIDER"] = "DARK_MODE_DIVIDER";
    ColorTokens["Mustard_Yellow"] = "Mustard_Yellow";
    ColorTokens["CINNAMON"] = "CINNAMON";
    ColorTokens["LIGHT_YELLOW"] = "LIGHT_YELLOW";
    ColorTokens["RED_ALERT"] = "RED_ALERT";
    ColorTokens["LIGHT_RED_ALERT"] = "LIGHT_RED_ALERT";
    ColorTokens["DARK_GREY_THEME"] = "DARK_GREY_THEME";
    ColorTokens["BACKGROUND_DARK_1"] = "BACKGROUND_DARK_1";
    ColorTokens["SYSTEM_ERROR_01"] = "SYSTEM_ERROR_01";
    ColorTokens["TATA_NEU_BG_COLOR"] = "TATA_NEU_BG_COLOR";
    ColorTokens["MUSTARD_YELLOW_1"] = "MUSTARD_YELLOW_1";
    ColorTokens["SYSTEM_WARNING_PRIMARY"] = "SYSTEM_WARNING_PRIMARY";
    ColorTokens["GREY_BACKGROUND"] = "GREY_BACKGROUND";
})(ColorTokens || (ColorTokens = {}));
export var GradientColorTokens;
(function (GradientColorTokens) {
    GradientColorTokens["B_1"] = "B_1";
    GradientColorTokens["D_1"] = "D_1";
    GradientColorTokens["D_2"] = "D_2";
    GradientColorTokens["D_3"] = "D_3";
    GradientColorTokens["D_4"] = "D_4";
    GradientColorTokens["D_5"] = "D_5";
    GradientColorTokens["D_6"] = "D_6";
    GradientColorTokens["D_7"] = "D_7";
    GradientColorTokens["D_8"] = "D_8";
    GradientColorTokens["D_9"] = "D_9";
    GradientColorTokens["D_10"] = "D_10";
    GradientColorTokens["IB_1"] = "IB_1";
    GradientColorTokens["IB_2"] = "IB_2";
    GradientColorTokens["IB_3"] = "IB_3";
    GradientColorTokens["IB_4"] = "IB_4";
    GradientColorTokens["IB_5"] = "IB_5";
    GradientColorTokens["IB_6"] = "IB_6";
    GradientColorTokens["IB_7"] = "IB_7";
})(GradientColorTokens || (GradientColorTokens = {}));
